import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import backend from '../middleware/backend'
import rootReducer from '../reducers';

export default function configureStore(router, initialState) {

	const enhancer = compose(
		applyMiddleware(thunk, backend),
		applyMiddleware(thunk, router)
	);

	return createStore(rootReducer, initialState, enhancer); // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/store/configureStore.production.js